import { makeStyles } from "@mui/styles";
import { Box } from "@mui/material";
import { WrapperStreakModalContent } from "./WrapperStreakModalContent";
import { IBackBehavior } from "../../../interfaces";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "fixed",
    top: 0,
    left: 0,
    backgroundColor: "#FAFAFA",
    zIndex: 5000,
  },
}));

interface WrapperStreakModalProps {
  open: boolean;
  streakModalInLearning: boolean;
  backBehavior: IBackBehavior;
  handleContinue: () => void;
  handleGoHome: () => void;
}

export const WrapperStreakModal = (props: WrapperStreakModalProps) => {
  const classes = useStyles();

  return (
    <>
      {props.open && (
        <Box className={classes.root}>
          <WrapperStreakModalContent
            streakModalInLearning={props.streakModalInLearning}
            backBehavior={props.backBehavior}
            handleContinue={props.handleContinue}
            handleGoHome={props.handleGoHome}
          />
        </Box>
      )}
    </>
  );
};
